import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import { UserInfo } from "../../../../context";
import AddEmployee from "./AddEmployee";
import EditEmployee from "./EditEmployee";

const EmployeeList = ({ positionList, rerun }) => {
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.lastname}, {text.firstname} {text.middle}
        </p>
      ),
    },
    {
      title: "Address",
      render: (text, record) => (
        <p style={{ textTransform: "uppercase" }}>
          {text.street}, {text.barangay}, {text.city}
        </p>
      ),
    },
    {
      title: "Contact #",
      dataIndex: "contact_no",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Position",
      dataIndex: ["merchantemployeeposition", "position"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getEmployeeList();
  }, [getEmployeeList]);

  const searchable = employeeList.data.filter((data) => {
    return (
      data.lastname.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.firstname.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Add Employee
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddEmployee
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          positionList={positionList}
        />
      )}

      {editDrawer && (
        <EditEmployee
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          selectedData={selectedData}
          positionList={positionList}
        />
      )}
    </>
  );
};

export default EmployeeList;
